import { render } from "./Store.vue?vue&type=template&id=0b665010"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import "./Store.vue?vue&type=style&index=0&id=0b665010&lang=css"
script.render = render

export default script